import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addButtonLabel: {
		id: 'polaris-common.fields.connection.editable-single-select.control.add-button-label',
		defaultMessage: 'Add',
		description: 'Button label for adding issues',
	},
});
